import script from "./CategoryMixin.vue?vue&type=script&lang=js"
export * from "./CategoryMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__